import { render, staticRenderFns } from "./SavedRFQ.vue?vue&type=template&id=64229d2e&scoped=true"
import script from "./SavedRFQ.vue?vue&type=script&lang=js"
export * from "./SavedRFQ.vue?vue&type=script&lang=js"
import style0 from "./SavedRFQ.vue?vue&type=style&index=0&id=64229d2e&prod&scoped=true&lang=css"
import style1 from "./SavedRFQ.vue?vue&type=style&index=1&id=64229d2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64229d2e",
  null
  
)

export default component.exports